import React from 'react'
const TvContext = React.createContext<{
  tvAppMode: boolean
  wellnessCheckInTodoId: string
  setWellnessCheckInTodoId: any
  symptomIds: any
  setSymptomIds: any
  session: string
}>({
  tvAppMode: false,
  wellnessCheckInTodoId: '',
  setWellnessCheckInTodoId: () => {},
  symptomIds: [],
  setSymptomIds: () => {},
  session: ''
})
export default TvContext
